// extracted by mini-css-extract-plugin
export default {"barometer":"BarometerSlideshow_barometer__IqQzS","container":"BarometerSlideshow_container__Oj40n"};